export enum RugbyUnionFoulAttribute {
  Offside = 2974,
  DangerousPlay = 2975,
}
